import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IndianRoundCurrency } from './currency-round.pipe';
import { IndianCurrency } from './currency.pipe';

@NgModule({
  declarations: [IndianCurrency, IndianRoundCurrency],
  imports: [CommonModule],
  exports: [IndianCurrency, IndianRoundCurrency]
})
export class CurrencyModule {}
